import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

const LOGO_URL = '/logo-givinghopes.png';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);
    if (result.success) {
      toast.success('Welcome back!');
      navigate('/dashboard');
    } else {
      toast.error(result.error);
    }
  };

  return (
    <div className="min-h-screen pt-16 flex items-center justify-center px-6 py-12 bg-[var(--bg-alt)]" data-testid="login-page">
      <div className="max-w-md w-full card-elevated p-8">
        <div className="flex items-center gap-3 mb-8">
          <img src={LOGO_URL} alt="Giving Hope" className="h-10 w-10 object-contain" />
          <span className="text-lg font-heading font-bold text-[var(--text-headline)]">
            Giving Hope <span className="text-[var(--primary-blue)]">LLC</span>
          </span>
        </div>

        <h2 className="text-3xl font-heading font-bold mb-2">Welcome Back</h2>
        <p className="text-[var(--text-body)] mb-8">Sign in to your account</p>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label htmlFor="email" className="block text-sm font-semibold mb-1.5 text-[var(--text-headline)]">Email</label>
            <input
              id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full px-4 py-3 rounded-xl border border-[var(--border-color)] bg-[var(--bg-alt)] focus:outline-none focus:ring-2 focus:ring-[var(--primary-blue)] text-sm"
              placeholder="you@example.com" data-testid="login-email-input"
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-semibold mb-1.5 text-[var(--text-headline)]">Password</label>
            <input
              id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="w-full px-4 py-3 rounded-xl border border-[var(--border-color)] bg-[var(--bg-alt)] focus:outline-none focus:ring-2 focus:ring-[var(--primary-blue)] text-sm"
              placeholder="Enter password" data-testid="login-password-input"
            />
          </div>
          <button type="submit" disabled={loading} className="w-full btn-primary disabled:opacity-50" data-testid="login-submit-btn">
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className="mt-6 text-center text-sm text-[var(--text-body)]">
          Don't have an account?{' '}
          <Link to="/register" className="text-[var(--primary-blue)] font-semibold hover:underline">Sign up</Link>
        </p>
      </div>
    </div>
  );
}
